import * as turf from '@turf/turf'

function findNearest(from: any, destinations: any) {
  const fromGeo = turf.point([from.lat, from.lng])

  const geoDestinations = destinations.map(({ lat, lng }: any) => turf.point([lat, lng]))
  const distances = geoDestinations.map((d: any) => turf.distance(fromGeo, d, { units: 'meters' }))

  const min = Math.min(...distances)
  const minIndex = distances.findIndex((n: any) => n === min)

  return { distance: min, destination: destinations[minIndex] }
}

export default findNearest



// WEBPACK FOOTER //
// ./src/lib/findNearest.ts